import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=f1c5bd14&scoped=true&"
import script from "./BaseRadio.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseRadio.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=f1c5bd14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c5bd14",
  null
  
)

export default component.exports